import EditIcon from '@mui/icons-material/Edit'
import { Button, ButtonProps } from '@mui/material'

import { Tooltip } from '../Tooltip'

interface Props extends ButtonProps {
  id: string
  buttonText: string
}

export const EditButton = ({ id, buttonText, ...props }: Props) => {
  return (
    <Tooltip title={buttonText} id={`${id}-tooltip`} test-id={`${id}-test`}>
      <Button
        id={id + '-button'}
        sx={{ marginTop: 0, marginBottom: -1 }}
        color="secondary"
        disableElevation
        size="small"
        variant="text"
        endIcon={<EditIcon />}
        {...props}
      >
        {buttonText}
      </Button>
    </Tooltip>
  )
}
